module.exports = __webpack_public_path__ + "img/step_first_white.433d03f3.svg";